import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const SplitApiSettings = createApi({
  baseQuery: fetchBaseQuery({
    //prepare headers work need to be done
    prepareHeaders: async (headers, { getState }) => {
      try {
        // const token = getState().auth?.token;
        let token =
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjIsImlzX2FkbWluIjpudWxsLCJpYXQiOjE3MDExMDUxNjksImV4cCI6MTcwMTEwODc2OX0.TfHaSQz8N3JTEFlzQv9FwXzd9pZjIuvdnuocsRVsEzw";
        if (true) {
          headers.set("authorization", `Bearer ${token}`);
          headers.set("accept", "application/json");
        } else {
          headers.set("authorization", "");
        }
      } catch (err) {
        headers.set("authorization", "");
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: [],
});
